import { createAsyncAction, } from 'typesafe-actions';

import * as types from './types';
import { repositories, } from 'api';
import { BasicApiException, } from 'common/types';

export const fetchProductsAttributes = createAsyncAction(
    types.FETCH_PRODUCTS_ATTRIBUTES_REQUEST,
    types.FETCH_PRODUCTS_ATTRIBUTES_SUCCEEDED,
    types.FETCH_PRODUCTS_ATTRIBUTES_FAILED,
)<never, Array<repositories.products.ProductAttributeType>, BasicApiException<types.ProductsAttributesErrorType>>();
